/* eslint-disable no-shadow */
import React from 'react';
import { Badge, Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { STAFF_LIST } from 'utils/CommonGraphQL';
import CardWithTitle from 'components/CardWithTitle';
import ProfileNameCard from 'components/ProfileNameCard';
import Loader from 'components/common/Loader';
import { modifiedUnderScore } from 'utils/constants';
import StaffVendorDetails from '../StaffVendorDetails';

const StaffDetails = ({ staffId, drawerToggle }) => {
  const { data, loading, error } = useQuery(STAFF_LIST, {
    variables: {
      filter: [{ key: 'id', value: staffId, type: 'INT', op: 'EQ' }],
    },
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.usersFilter?.users) return 'Staff not available';

  const staffDetail = data.usersFilter.users[0];

  const roleList = staffDetail.roles?.filter(
    (rle) =>
      rle?.name === 'SALES_EXECUTIVE' ||
      rle?.name === 'SALES_HEAD' ||
      rle?.name === 'BDE',
  );

  return (
    <div>
      <CardWithTitle title="Personal Details">
        <Row>
          <Col sm={6}>
            <div className="d-flex align-items-center mb-2">
              <ProfileNameCard
                wrapperClass=""
                profile={staffDetail?.profile}
                fname={
                  staffDetail?.firstName && staffDetail?.firstName.charAt(0)
                }
                lname={staffDetail?.lastName && staffDetail?.lastName.charAt(0)}
              />
              <div className="ms-3">
                <p className="f-14 text-dark-525 mb-1 fw-medium text-capitalize">{`${staffDetail?.firstName} ${staffDetail?.lastName}`}</p>
                <p className="f-12 mb-0 text-dark-525 fw-medium text-break">
                  {staffDetail?.email ? staffDetail?.email : 'Not Available'}
                </p>
              </div>
            </div>
          </Col>
          <Col sm={4}>
            <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
              PHONE NUMBER
            </span>
            <span className="f-12 text-dark-525 fw-medium d-block">
              {staffDetail?.phone
                ? `${staffDetail?.callingCode?.callingCode}${staffDetail?.phone}`
                : 'Not Available'}
            </span>
          </Col>
        </Row>
      </CardWithTitle>
      {/* <CardWithTitle title="Identification">
        <Row>
          <Col sm={4} xxl={3} className="mb-2">
            <span className="f-12 text-active fw-medium text-uppercase d-block">
              Aadhaar
            </span>
            <span className="d-block">
              <Button
                className="f-12 fw-medium p-0 mb-0 text-decoration-none"
                color="link"
              >
                Aadhaar front.pdf
              </Button>
            </span>
            <span className="d-block">
              <Button
                className="f-12 fw-medium p-0 text-decoration-none"
                color="link"
              >
                Aadhaar back.pdf
              </Button>
            </span>
          </Col>
          <Col sm={4} xxl={3} className="mb-2">
            <span className="f-12 text-active fw-medium d-block text-uppercase">
              Pancard
            </span>
            <span className="d-block">
              <Button
                className="f-12 fw-medium p-0 text-decoration-none"
                color="link"
              >
                Pancard.pdf
              </Button>
            </span>
          </Col>
        </Row>
      </CardWithTitle> */}
      <CardWithTitle title="Permissions">
        <Row>
          <Col sm={4} xxl={3} className="mb-2">
            <span className="f-12 text-active fw-medium text-uppercase d-block">
              DEPARTMENT
            </span>
            <span className="f- 12 text-dark-525 fw-medium d-block">
              {staffDetail?.roles
                ? staffDetail?.roles.map((rolesData) => {
                    return (
                      <Badge
                        key={rolesData.id}
                        size="s"
                        className="me-1 text-dark fw-semibold"
                        color="light"
                      >
                        {modifiedUnderScore(rolesData?.name)}
                      </Badge>
                    );
                  })
                : 'Not Available'}
            </span>
          </Col>
          <Col sm={8} xxl={9} className="mb-2">
            <span className="f-12 text-active fw-medium d-block text-uppercase">
              PERMISSION
            </span>
            <span className="f -12 text-dark-525 fw-medium d-block">
              {staffDetail?.permissions
                ? staffDetail?.permissions.map((data) => {
                    return (
                      <Badge
                        key={data.id}
                        size="s"
                        className="me-1 text-dark fw-semibold"
                        color="light"
                      >
                        {data?.permissionName}
                      </Badge>
                    );
                  })
                : 'Not Available'}
            </span>
          </Col>
        </Row>
      </CardWithTitle>
      {roleList?.length ? (
        <StaffVendorDetails
          drawerToggle={drawerToggle}
          staffId={staffDetail?.id}
          roleList={
            staffDetail.roles?.filter((rle) => rle?.name === 'BDE') || []
          }
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default StaffDetails;
